import { render } from "./List.vue?vue&type=template&id=5d541628&ts=true"
import script from "@/composables/pages/master-setting/route/ListComposable?vue&type=script&lang=ts"
export * from "@/composables/pages/master-setting/route/ListComposable?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=5d541628&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__